import { useFormatter } from 'js/hooks/useFormatter';

export const MoneyCell = ({ name, row }) => {
    const formatter = useFormatter();

    if (!row[name]) {
        return null;
    }

    return formatter.formatCurrency(row[name]);
};
